import { Sparkles } from "lucide-react";

function toneFor(score) {
  if (score >= 80) return { ring: "border-emerald-400/60", bg: "bg-emerald-500/10", text: "text-emerald-300" };
  if (score >= 60) return { ring: "border-nexus-blue/60", bg: "bg-nexus-blue/10", text: "text-nexus-blue" };
  if (score >= 40) return { ring: "border-nexus-purple/60", bg: "bg-nexus-purple/10", text: "text-nexus-purple" };
  return { ring: "border-nexus-pink/60", bg: "bg-nexus-pink/10", text: "text-nexus-pink" };
}

export default function MatchScoreChip({ match, testId }) {
  if (!match || typeof match.score !== "number") {
    return (
      <span
        className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest px-2 py-1 rounded-full border border-white/10 bg-white/[0.02] text-zinc-500"
        data-testid={testId || "match-score-pending"}
      >
        <Sparkles className="h-3 w-3" /> scoring…
      </span>
    );
  }
  const t = toneFor(match.score);
  return (
    <span
      title={match.rationale}
      className={`inline-flex items-center gap-1.5 text-[11px] font-bold px-2.5 py-1 rounded-full border ${t.ring} ${t.bg} ${t.text}`}
      data-testid={testId || `match-score-${match.score}`}
    >
      <Sparkles className="h-3 w-3" /> {match.score}% match
    </span>
  );
}

export function MatchScoreDetail({ match }) {
  if (!match || typeof match.score !== "number") return null;
  const t = toneFor(match.score);
  return (
    <div className="mt-3 p-3 rounded-xl bg-white/[0.02] hairline space-y-2" data-testid="match-score-detail">
      <div className="flex items-center gap-2">
        <MatchScoreChip match={match} />
        <span className="text-xs text-zinc-400">{match.rationale}</span>
      </div>
      {match.strengths?.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {match.strengths.map((s, i) => (
            <span key={i} className={`text-[10px] px-2 py-0.5 rounded-full ${t.bg} ${t.text} border ${t.ring}`}>
              + {s}
            </span>
          ))}
        </div>
      )}
      {match.concerns?.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {match.concerns.map((s, i) => (
            <span key={i} className="text-[10px] px-2 py-0.5 rounded-full border border-white/10 bg-white/[0.02] text-zinc-400">
              − {s}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
